<template src="./retryToPay.html"></template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { axiosRequests } from '../../../services/axiosinstance';
    import { editUrl, getFormatedAmount, checkIfClickInsideAlert } from '../../../services/helper';
    import { Routes } from '../../../const';
    import { RadioModel } from '../../../models/GUIModels';

    interface ComponentModel {
        isButtonDisabled: boolean,
        availableMethod: RadioModel[],
        selectedMethod: RadioModel | null,
        isShowAlert: boolean,
        alertText: string,
    }

    export default defineComponent({
        name: 'RetryToPay',
        props: ["client"],
        emits: ["close"],
        data(): ComponentModel {
            return {
                isButtonDisabled: false,
                availableMethod: [],
                selectedMethod: null,
                isShowAlert: false,
                alertText: "",
            }
        },
        methods: {
            clickOutside: function (event: any) {
                if (!checkIfClickInsideAlert(event.target)) this.close();
            },
            close: function () {
                this.$emit("close", false);
            },
            save: function () {
                this.isShowAlert = false;
                this.isButtonDisabled = true;

                let data = { clientId: this.client.id, trainingId: this.client.trainingId, paymentMethod: this.selectedMethod?.value };

                axiosRequests.post(editUrl(Routes.retryToPayTraining), data)
                    .then(
                        () => {
                            this.$emit("close", true);
                        }
                    )
                    .catch(
                        async (err: any) => {
                            this.isButtonDisabled = false;

                            if (err.status == 401) {
                                return;
                            } else if (err.status == 403) {
                                this.$router.push('/forbidden');
                            } else if (err.status == 400 && err.data) {
                                this.$store.commit('SET_ADD_ERROR', err.data);
                            } else {
                                this.$store.commit('SET_ADD_ERROR', 'error.something_went_wrong');
                            }
                        }
                    );

            },
            clickOnSaveButton: function () {
                if (this.selectedMethod?.value == "pos") {
                    this.alertText = 'timetable.retry_to_pay.pos_alert';
                    this.isShowAlert = true;
                } else if (this.selectedMethod?.value == "cash") {
                    this.alertText = 'timetable.retry_to_pay.cash_alert';
                    this.isShowAlert = true;
                } else {
                    this.save();
                }
            },
            checkPressedButton: function (event: any) {
                if (event.keyCode == 27) this.close();
            },
            getFormatedAmount
        },
        beforeMount() {
            if (!this.client) return;

            this.availableMethod.push({ label: 'training_payment_method.pos', isTranslated: true, value: "pos" });
            this.availableMethod.push({ label: 'training_payment_method.cash', isTranslated: true, value: "cash" });

            if (this.client.hasPaymentMean) this.availableMethod.push({ label: 'training_payment_method.linked_card', isTranslated: true, value: "linkedCard" });
            if (this.client.hasTrainingBlock) this.availableMethod.push({ label: 'training_payment_method.training_block', isTranslated: true, value: "trainingBlock" });

            this.selectedMethod = { label: 'training_payment_method.pos', isTranslated: true, value: "pos" };
        },
        mounted() {
            window.addEventListener('keyup', this.checkPressedButton);
        },
        beforeUnmount() {
            window.removeEventListener('keyup', this.checkPressedButton);
        }
    });
</script>

<style scoped>
    .retry_to_pay_wrapper {
        position: fixed;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        background-color: #b5b4b466;
        z-index: 10000;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .retry_to_pay_body {
        background-color: white;
        max-width: 480px;
        width: max-content;
        border-radius: 24px;
        overflow: hidden;
        animation: show 0.6s linear;
    }

    .retry_to_pay_title {
        font-size: 17px;
        letter-spacing: 1px;
        font-weight: 600;
        background-color: #f6f7f8;
        padding: 16px 24px;
    }

    .retry_to_pay {
        margin-top: 12px;
        padding: 0px 24px;
    }

    .retry_to_pay_buttons_wrapper {
        margin-top: 12px;
        display: flex;
        padding: 0px 24px;
        margin-bottom: 8px;
    }

    .button_space {
        margin-left: 16px;
    }

    @media(max-width: 500px) {
        .retry_to_pay_body {
            width: 98%;
        }

        .button_space {
            margin-left: 0px;
        }

        .retry_to_pay_buttons_wrapper {
            display: block;
        }

        .retry_to_pay_content_wrapper {
            max-height: calc(100vh - 90px);
            overflow: auto;
        }
    }
</style>